import { ChangeDetectorRef, Component } from '@angular/core';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-airdisk-left',
  templateUrl: './airdisk-left.component.html',
  styleUrls: ['./airdisk-left.component.scss'],
  standalone: false
})
export class AirdiskLeftComponent {

  currentComponent: any;
  isMobile: any;
  iconToggler: boolean = true;
  private readonly destroy$ = new Subject<void>();

  constructor(public airdiskService: AirdiskbrakeService, private readonly cdr: ChangeDetectorRef, private readonly BreakpointObserver: BreakpointObserver) {
    this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  SelectedComponent(componentName, event) {
    event.preventDefault();
    this.airdiskService.valueDisclaimer$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      console.log("xx", x)
      if (x) {
        this.airdiskService.currentComponent$.next(componentName);
      } else {
        componentName = 'visitorInfo';
      }
    })

  }

  ngOnInit() {
    this.airdiskService.currentComponent$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      if (x != null) {
        this.currentComponent = x;
      } else {
        this.currentComponent = 'visitorInfo';
      }
      this.cdr.detectChanges();
    })
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
